import { JSX } from "react"
import { Typography } from "@mui/material"
export type StudentModalType = "MOVE_STUDENT_WARNING" | "EXPIRE_STUDENT" | "STUDENT_IS_EXPIRED" | "NO_EMAIL_FOUND"


export const StudentModalMessage = {
    'EXPIRE_STUDENT': (
        <Typography>
            Launching Tweenscreen will no longer be available for this child if Expired. Do you wish to proceed?
        </Typography>
    ),
    'NO_EMAIL_FOUND': (
        <div>
            <Typography>
                There is no email on file for this child.
            </Typography>
            <Typography sx={{ padding: "8px 0px" }}>
                Please have your Admin update the child’s profile to support the remote launch option.
            </Typography>
        </div>
    ),
    'STUDENT_IS_EXPIRED': (
        <div>
            <Typography>
                This student's account is expired.
            </Typography>
            <Typography sx={{ padding: "8px 0px" }}>
                Please have your Admin update the child’s profile to launch new sessions.
            </Typography>
        </div>
    ), 'PARENTAL_CONSENT_SENT': (
        <div>
            <Typography>SUCCESS!</Typography>
            <Typography sx={{ padding: "8px 0px" }}>
                An email containing a link for parental consent was sent
            </Typography>
            <Typography>You can find a record of this in Summary Notes</Typography>
        </div>
    ),
    "PARENTAL_CONSENT_ERROR": (
        <div>
            <Typography>Error</Typography>
            <Typography sx={{ padding: "8px 0px" }}>
                An error has occured, please try again in a moment
            </Typography>
        </div>
    ),
    'PARENTAL_CONSENT_SUCCESS': (
        <div>
            <Typography>Success!</Typography>
            <Typography sx={{ padding: "8px 0px" }}>
                An email containing a copy of the completed consent form will be sent to you.
            </Typography>
        </div>
    ),
    'TRUESAGE_INFORMATION_SENT': (
        <div>
            <Typography>SUCCESS!</Typography>
            <Typography>An email containing the selected documents was sent</Typography>
        </div>
    ),
    "PARENTAL_CONSENT_PENDING": (
        <div>
            <Typography>Can't launch session</Typography>
            <Typography>Parental consent still pending</Typography>
        </div>),
    "PARENTAL_CONSENT_NOT_GIVEN": (
        <div>
            <Typography>Can't launch session</Typography>
            <Typography>Parent did not give their consent</Typography>
        </div>
    ),
    "MOVE_STUDENT_WARNING": (
        <div>
            <Typography>Are you sure?</Typography>
            <Typography>Transfering a student to a new location will remove access for people at the old location</Typography>
        </div>
    )
}
